<div class="d-flex flex-column flex-grow-1 w-100">
    <div class="ws-section__header attachment-bundler-header pt-3 border-bottom-0 pb-2"
         [class.attachment-bundler-sticky-header]="isStickyHeaderEnabled">
        <h4 class="ws-section__header__title page-title">Attachment Bundler: {{ currentStep?.title }}</h4>
        <div class="ws-section__header__actions">
            @if (currentStep === processStep) {
                <div class="ws-section__header__actions__item">
                    <button type="button"
                            class="ace-btn btn-sm btn-secondary me-2"
                            data-qa="bundler-back"
                            helpTooltip
                            helpContentId="app.back"
                            [disabled]="loading"
                            (click)="previousStep()">
                        Back
                    </button>
                </div>
            }
            @if (isDialogMode) {
                <div class="ws-section__header__actions__item">
                    <button type="button"
                            class="ace-btn btn-sm btn-secondary me-2"
                            data-qa="bundler-cancel"
                            [disabled]="loading"
                            (click)="cancelDialog()">
                        Cancel
                    </button>
                </div>
            }
            <div class="ws-section__header__actions__item">
                <button type="button"
                        class="ace-btn btn-sm btn-primary"
                        data-qa="bundler-next"
                        [disabled]="loading || !nextButtonEnabled"
                        (click)="nextStep()">
                    {{ currentStep?.buttonText ?? currentStep?.title }}
                </button>
            </div>
        </div>
    </div>
    <div class="d-flex flex-column flex-grow-1 w-100">
        @if (currentStep !== processStep) {
            <div class="d-flex flex-column">
                <bundler-filters [filterScope]="reportType"></bundler-filters>
                <bundler-organize-list [bundlerTarget]="bundlerTarget()"></bundler-organize-list>
            </div>

        }

        @if (currentStep === processStep) {
            @if (loading) {
                <ws-ace-loader></ws-ace-loader>
            }
            <bundler-selection-list (formValid)="nextButtonEnabled = $event"></bundler-selection-list>
        }
    </div>
</div>
